import React from 'react';
import {useTranslation} from 'react-i18next';

/**
 * Una espera del túnel, con lo que está pasando dicho.
 *
 * Las cuatro esperas del recorrido eran un `box-loader` con un spinner y ni una palabra: la puerta
 * de entrada —hasta ocho segundos, justo después de crear la agencia—, la de cada paso —que es la
 * que se ve al VOLVER de autorizar una plataforma—, la del paso 3 y la del paso 4. La del paso 3 es
 * la peor: la consulta más cara del recorrido deja la pantalla entera en blanco con un spinner
 * chico en el medio, y sin texto no distingue «faltan dos segundos» de «esto se colgó».
 *
 * Es el mismo criterio que el paso 2 ya aplica a «Buscando tus cuentas…» y el paso 4 a «N de M
 * cuentas listas»: la espera se narra, no se esconde. Acá sólo faltaba hacerlo donde el spinner
 * ocupa la pantalla en vez de una línea.
 *
 * **`standalone` no es cosmético: sin él no hay spinner.** Toda la paleta del túnel
 * (`--ob-line`, `--ob-red`, `--ob-ink`…) está declarada **sobre `.ob-tunnel`**, y las dos esperas de
 * `OnboardingGate` se montan FUERA de ese elemento — el Gate cuelga directo de la ruta y el Guard
 * devuelve esto *en lugar* de `OnboardingLayout`, que es el único que pinta la clase. Sin ancestro,
 * `.ob-spinner-big` resuelve `border: 3px solid var(--ob-line)` con la variable indefinida: la
 * declaración entera es inválida, `border-style` cae a `none` y queda **un div de 52×52 sin borde**.
 * O sea ocho segundos de texto quieto, sin una sola señal de movimiento, en la primera pantalla
 * después de crear la agencia — peor que el `box-loader` que este componente vino a reemplazar.
 *
 * Los pasos que ya viven dentro del túnel (3 y 4) lo usan SIN `standalone`: anidar otro `.ob-tunnel`
 * —que es `position: fixed` con su propio scroll— metería un segundo scroller adentro del primero.
 *
 * No lleva `aria-live`: una live region tiene que existir en el DOM **antes** de que su contenido
 * cambie, y acá la región y su texto montan juntos, que es justamente el caso que los lectores de
 * pantalla no anuncian. El texto se lee solo, como contenido nuevo de la pantalla.
 */
export function ObLoading({titleKey, hintKey, standalone = false}) {
    const {t} = useTranslation();

    const body = (
        <div className="ob-loading">
            <span className="ob-spinner-big" aria-hidden="true"/>
            <p className="ob-loading__title">{t(titleKey)}</p>
            {hintKey && <p className="ob-loading__hint">{t(hintKey)}</p>}
        </div>
    );

    return standalone ? <div className="ob-tunnel">{body}</div> : body;
}

export default ObLoading;
